module.exports = __webpack_public_path__ + "img/usericon.17e44efd.jpg";